/** The eight page states every archetype page in the visual grammar switches through. */
export const FM_GALLERY_PAGE_STATES = [
  'ready',
  'loading',
  'empty',
  'partial',
  'stale',
  'locked',
  'error',
  'long-copy',
] as const;

export type FmGalleryPageState = (typeof FM_GALLERY_PAGE_STATES)[number];

/** Specimen id per page state; every archetype page names all eight. */
export type FmGalleryStatePage = Readonly<Record<FmGalleryPageState, string>>;

export interface FmGallerySpecimen {
  id: string;
  label: string;
}

/** Fails loudly when a state names a specimen the archetype no longer has. */
export function assertGalleryStatePage(
  states: FmGalleryStatePage,
  specimens: readonly FmGallerySpecimen[],
  archetype: string,
): void {
  const ids = new Set(specimens.map(({ id }) => id));
  const missing = FM_GALLERY_PAGE_STATES.filter((state) => !ids.has(states[state]));
  if (missing.length > 0) {
    throw new Error(
      `${archetype} page states name specimens that do not exist: ${missing
        .map((state) => `${state} → "${states[state]}"`)
        .join(', ')}`,
    );
  }
}
